import React, { useMemo } from 'react';
import PropTypes, {
    string,
    func,
    bool,
    number,
    arrayOf,
    shape
} from 'prop-types';

import { VideosListing, DocumentsListing } from '.';

const MediaRoomListing = ({
    filters,
    items,
    configName,
    handleShowAllClick
}) => {
    const category = useMemo(() => {
        if (!filters || !Array.isArray(filters) || !filters.length) {
            return null;
        }

        const selectedFilter = filters.find(
            filter => filter.radio && filter.radio.checked
        );

        if (!selectedFilter) {
            return null;
        }

        return selectedFilter.category;
    }, [filters]);

    const renderListingByCategory = (category, items) => {
        switch (category) {
            case 'videos': {
                return <VideosListing items={items} />;
            }

            case 'documents': {
                return (
                    <DocumentsListing
                        configName={configName}
                        groups={items}
                        handleShowAllClick={handleShowAllClick}
                    />
                );
            }

            default:
                return null;
        }
    };

    if (!items || !items.length) {
        return null;
    }

    return (
        <React.Fragment>
            {renderListingByCategory(category, items)}
        </React.Fragment>
    );
};

MediaRoomListing.propTypes = {
    filters: arrayOf(shape({})).isRequired,
    items: PropTypes.oneOfType([
        arrayOf(
            shape({
                badges: arrayOf(
                    shape({
                        bgColor: string,
                        color: string,
                        id: string,
                        title: string
                    })
                ),
                buttonTitle: string.isRequired,
                url: string.isRequired,
                target: string,
                thumbnailAlt: string,
                estimate: string.isRequired,
                language: string.isRequired,
                date: string.isRequired,
                dateTitle: string.isRequired,
                filesCount: number,
                filesTitle: string,
                description: string.isRequired,
                title: string.isRequired,
                videoId: string.isRequired
            })
        ),
        arrayOf(
            shape({
                id: string,
                title: string,
                category: string,
                itemAmount: number,
                showAll: bool,
                items: arrayOf(
                    shape({
                        blocked: bool,
                        url: string.isRequired,
                        title: string.isRequired,
                        size: string.isRequired,
                        blockedTitle: string,
                        downloadTitle: string
                    })
                )
            })
        )
    ]).isRequired,
    configName: string.isRequired,
    handleShowAllClick: func.isRequired
};

export default MediaRoomListing;
